import React from 'react';
import { SIGNAL } from '../utils/signalEngine';
import CoverageBadge from './CoverageBadge';

const signalConfig = {
  [SIGNAL.GREEN]: {
    cssClass: 'signal-green',
    label: 'ALL CLEAR',
    sublabel: 'Bond market favorable',
    animClass: 'animate-pulse-green',
    ringColor: 'ring-signal-green/30',
    textColor: 'text-signal-green',
  },
  [SIGNAL.YELLOW]: {
    cssClass: 'signal-yellow',
    label: 'CAUTION',
    sublabel: 'Warning signals emerging',
    animClass: 'animate-pulse-yellow',
    ringColor: 'ring-signal-yellow/30',
    textColor: 'text-signal-yellow',
  },
  [SIGNAL.ORANGE]: {
    cssClass: 'signal-orange',
    label: 'ELEVATED',
    sublabel: 'Multiple warnings active — reduce exposure',
    animClass: 'animate-pulse-orange',
    ringColor: 'ring-signal-orange/30',
    textColor: 'text-signal-orange',
  },
  [SIGNAL.RED]: {
    cssClass: 'signal-red',
    label: 'DANGER',
    sublabel: 'Deleverage immediately',
    animClass: 'animate-pulse-red',
    ringColor: 'ring-signal-red/30',
    textColor: 'text-signal-red',
  },
};

export default function MasterSignalLight({ signal = SIGNAL.GREEN, score = 0, coverage = null }) {
  const config = signalConfig[signal] || signalConfig[SIGNAL.GREEN];

  return (
    <div className="flex flex-col items-center gap-6 animate-fade-in">
      <div className="relative">
        <div className={`absolute inset-[-12px] rounded-full border-2 ${config.ringColor} opacity-60`} />
        <div className={`absolute inset-[-24px] rounded-full border ${config.ringColor} opacity-30`} />
        <div className={`signal-light ${config.cssClass} ${config.animClass} flex items-center justify-center`}>
          <span className="text-white/90 font-display font-bold text-lg tracking-wide drop-shadow-lg">
            {score}
          </span>
        </div>
      </div>
      <div className="text-center">
        <h2 className={`font-display font-bold text-2xl tracking-wider ${config.textColor}`}>
          {config.label}
        </h2>
        <p className="text-mentor-muted text-sm mt-1 font-body">
          {config.sublabel}
        </p>
        {coverage && (
          <div className="mt-3 flex flex-col items-center gap-1.5">
            <div className="flex items-center gap-1.5">
              {coverage.mode === 'live' ? (
                <CoverageBadge
                  coverage={coverage.livePercent >= 90 ? 'live' : coverage.livePercent >= 60 ? 'estimated' : 'placeholder'}
                  title={`${coverage.livePercent}% of this signal is built from genuinely live data right now.`}
                />
              ) : (
                <CoverageBadge coverage="demo" />
              )}
              <span className="text-[11px] font-display font-bold text-mentor-text">
                {coverage.summary}
              </span>
            </div>
            {coverage.mode === 'live' && coverage.counts.placeholder > 0 && (
              <p className="text-[10px] text-mentor-muted max-w-[15rem] leading-relaxed">
                {coverage.counts.placeholder} component{coverage.counts.placeholder === 1 ? '' : 's'} still use a placeholder value pending live data.
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
